import React from 'react';
import BrandTooltip from 'components/consumer/BrandTooltip';
import IconGreenguardGold from './IconGreenguardGold';

const IconWithTooltipGreenguardGold = props => (
  <BrandTooltip
    openOnHover
    textColor="brand"
    align="standard"
    direction="top"
    showInfoIcon={false}
    showCloseButton={false}
    leftOffsetOverride={0}
    customIcon={<IconGreenguardGold {...props} />}
  >
    <div className="font-bold mb-2">GREENGUARD Gold Certified</div>
    <p>
      This piece was screened for 10,000+ chemicals and emissions, contributing
      to cleaner air in your home.
    </p>
  </BrandTooltip>
);

export default IconWithTooltipGreenguardGold;
